import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';

import FileTextOutlined from '@ant-design/icons/FileTextOutlined';
import LockOutlined from '@ant-design/icons/LockOutlined';
import QuestionCircleOutlined from '@ant-design/icons/QuestionCircleOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';

const LINKS = [
  {
    icon: <QuestionCircleOutlined />,
    label: 'Support',
    sub: 'Get help from our team',
    href: 'https://zenigmalabs.com/',
    badge: null
  },
  {
    icon: <UserOutlined />,
    label: 'About Us',
    sub: 'Learn about Zenigma Labs',
    href: 'https://zenigmalabs.com/',
    badge: null
  },
  {
    icon: <LockOutlined />,
    label: 'Privacy Policy',
    sub: 'How we handle your data',
    href: '/privacypolicy',
    badge: null
  },
  {
    icon: <FileTextOutlined />,
    label: 'Terms of Use',
    sub: 'Read our terms and conditions',
    href: '/termsofservice',
    badge: null
  }
];

export default function SettingTab() {
  return (
    <Box sx={{ py: 0.5 }}>
      <Typography
        sx={{
          px: 2,
          pt: 1.2,
          pb: 0.4,
          fontSize: 10,
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.07em',
          color: 'text.disabled'
        }}
      >
        Help & Legal
      </Typography>

      {LINKS.map((item) => (
        <Box
          key={item.label}
          component="a"
          href={item.href}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            px: 2,
            py: 1.1,
            textDecoration: 'none',
            cursor: 'pointer',
            transition: 'background 0.12s',
            '&:hover': { bgcolor: 'rgba(0,0,0,0.03)' },
            '&:hover .si-icon': { bgcolor: 'rgba(25,118,210,0.08)', color: 'primary.main' }
          }}
        >
          {/* Icon */}
          <Box
            className="si-icon"
            sx={{
              width: 34,
              height: 34,
              borderRadius: '9px',
              bgcolor: 'rgba(0,0,0,0.04)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 15,
              color: 'text.secondary',
              transition: 'all 0.12s',
              flexShrink: 0
            }}
          >
            {item.icon}
          </Box>

          {/* Text */}
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography sx={{ fontSize: 13, fontWeight: 500, color: 'text.primary', lineHeight: 1.2 }}>{item.label}</Typography>
            <Typography sx={{ fontSize: 11, color: 'text.disabled', mt: 0.2 }}>{item.sub}</Typography>
          </Box>

          {/* Badge + external icon */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8, flexShrink: 0 }}>
            {item.badge && (
              <Chip label={item.badge.label} size="small" color={item.badge.color} sx={{ fontSize: 10, height: 18, fontWeight: 600 }} />
            )}
            <Typography sx={{ fontSize: 13, color: 'text.disabled', lineHeight: 1 }}>↗</Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
}
